import axios from "axios";
import { Base_URL } from "../url";

export const saveGrade = async (gradeData, userName) => {
  try {
    const response = await axios.post(
      `${Base_URL}/GradeMaster?UserName=${userName}`,
      gradeData,
      {
        headers: { "Content-Type": "application/json" },
      }
    );
    return response.data;
  } catch (error) {
    throw error.response?.data || "Error saving grade details!";
  }
};